import { useQuery } from "@tanstack/react-query";

import { getMetaFunctions } from "../../services/meta_functions";

const useGetMetaFunctions = () => {

    const queryFn = async () => {
        return await getMetaFunctions();
    };

    return useQuery({
        queryKey: ['meta_functions'],
        queryFn,
        retry: 0,
    });
};

export default useGetMetaFunctions;